import {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import FormSkeleton from '../../../../components/Skeletons/FormSkeleton';
import HttpService from '../../../../services/HttpService';
import RoleForm from '../_features/RoleForm';

const ViewInternalRole = () => {

  const { id } = useParams();

  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const getData = async () => {
    try {      
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/authorization/groups/${id}/roles`);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const role_info = [
    {
      name: 'Περιγραφή Ρόλου:',
      value: data.description
    }
  ];
  
  return (
    <> 
      {isLoading
        ? <FormSkeleton lines={4} />
        : <RoleForm view
          internal={true}
          title={data.name} 
          initialValues={data} 
          permissionCategories={data.roles}
          detailsRows={role_info}
        />}
    </>
  );
};

export default ViewInternalRole;